/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      const loadMoreContainer = $( '.events__row' )[0];

      $( '.events__filter' ).on( 'change', function() {
        $( loadMoreContainer ).html( '' );
        $( loadMoreContainer ).attr( 'data-page', 1 );
        $( loadMoreContainer ).attr( 'data-showing', 0 );

        loadMoreEvents();
      } );

      $( '.load-more' ).on( 'click', function() {
        loadMoreEvents();
      } );

      function loadMoreEvents() {
        const data = {
          'ppp': $( loadMoreContainer ).attr( 'data-ppp' ),
          'page': $( loadMoreContainer ).attr( 'data-page' ),
          'type': $( '.events__filter' ).val(),
        };

        $.ajax( {
          type: 'GET',
          url: site_info.wpApiSettings.ll + 'events/filter',
          data: data,
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', site_info.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            // $( '.events__row' ).html( data );
            console.log( data );
            const loadMorePPP = $( loadMoreContainer ).attr( 'data-ppp' );
            const loadMorePage = $( loadMoreContainer ).attr( 'data-page' );
            $( loadMoreContainer ).append( data.content );
            $( loadMoreContainer ).attr( 'data-page', parseInt( loadMorePage ) + 1 );
            $( loadMoreContainer ).attr( 'data-showing', ( parseInt( loadMorePPP ) * ( parseInt( loadMorePage ) ) ) );

            if ( data.count < loadMorePPP ) {
              $( '.load-more' ).hide();
            } else {
              $( '.load-more' ).show();
            }
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'events-filter', COMPONENT );
} )( app );
